import React, { useEffect, useRef, useState } from 'react';
import { CloseIcon } from '../../../../../utils/svg';

function NewPopupLayout({
  customClass,
  onCloseIconClicked,
  children,
  childrendiv,
  parentdiv,
  subdiv,
  scrollPopup = false,
  popupStyle,
  width,
  position,
  closeIcon = <CloseIcon />
}) {
  const popLayoutRef = useRef(null);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popLayoutRef.current && !popLayoutRef.current.contains(event.target)) {
        onCloseIconClicked();
      }
    };

    const handleClickInside = (event) => {
      event.stopPropagation();
    };

    document.addEventListener('mousedown', handleOutsideClick);
    popLayoutRef.current?.addEventListener('mousedown', handleClickInside);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      popLayoutRef.current?.removeEventListener('mousedown', handleClickInside);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="inset-0 z-[99]">
      <div
        className="fixed inset-0 z-[99] overflow-y-auto h-screen"
        style={{ backgroundColor: 'var(--overlay-modal-strong)', ...popupStyle }}
      >
        <div
          className={`w-full h-[100dvh] top-0 md:h-auto md:left-0 md:right-0 ml-auto mr-auto rounded-tl-3xl rounded-tr-3xl absolute bottom-0 md:bottom-auto md:mt-20 lg:mt-[100px] flex justify-center ${position || ''}`}
          onClick={onCloseIconClicked}
        >
          <div
            ref={popLayoutRef}
            className={`${parentdiv} w-full md:w-auto rounded-tl-2xl rounded-tr-3xl md:rounded-[14px] absolute md:inset-x-auto md:inset-y-auto md:top-22 bottom-0 md:bottom-auto`}
          >
            <div className={`${customClass || 'md:w-[492px]'} w-full rounded-[10px]`}>
              <div
                className={`flex flex-col w-full rounded-tl-2xl rounded-tr-3xl md:rounded-[14px] ${viewportHeight <= 650 ? 'h-[80vh]' : ''} md:h-full ${subdiv} bg-white md:bg-transparent`}
              >
                <div
                  onClick={onCloseIconClicked}
                  className="self-end absolute top-3 right-3 cursor-pointer"
                >
                  {closeIcon}
                </div>
                <div
                  className={`md:mb-[30px] bg-white md:rounded-[14px] rounded-tr-3xl rounded-tl-3xl ${
                    childrendiv
                      ? `${childrendiv} overflow-x-auto flex flex-col justify-center`
                      : `pt-10 px-[30px] md:p-10 overflow-x-auto flex flex-col justify-center`
                  }`}
                  onClick={(e) => e.stopPropagation()}
                >
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewPopupLayout;
